import { useChannelAgnosticDraftsEnabled } from '~publish/hooks/useChannelAgnosticDraftsEnabled'

import { useIsPreviewMode } from '../store/appSlice/hooks'
import { useSelectedChannels } from '../store/channelSlice/hooks'

/**
 * True when the composer is authoring the channel-less omni draft rather
 * than a channel-specific post — the same gate useSaveCallbacks uses to
 * route Save Draft to createContentItemDraft/updateContentItemDraft instead
 * of the per-channel GraphQL save. Preview mode counts as channel-less: its
 * selectable "channels" are placeholders for channels to connect, not real
 * post targets.
 */
export function useIsChannelLessDraftMode(): boolean {
  const channelLessEnabled = useChannelAgnosticDraftsEnabled()
  const selectedChannels = useSelectedChannels()
  const isPreviewMode = useIsPreviewMode()

  return channelLessEnabled && (isPreviewMode || selectedChannels.length === 0)
}
